<template>
  <header class="header">
    <div class="header-container">
      <div class="logo">
        <router-link to="/" class="logo-link">
          <img src="@/assets/images/vn_logo.png" alt="Vogue Nomad Logo">
        </router-link>
      </div>

      <nav class="nav">
        <router-link to="/" class="nav-link">{{ $t('nav.home') }}</router-link>

        <div class="nav-dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <div class="nav-dropdown-toggle-container">
            <a href="javascript:void(0)" class="nav-dropdown-toggle">{{ $t('nav.advantages') }}</a>
            <span class="nav-dropdown-icon"></span>
          </div>

          <div class="nav-dropdown-menu" :class="{ active: showDropdown }">
            <router-link to="/sourcing" class="nav-dropdown-item">{{ $t('nav.sourcing') }}</router-link>
            <router-link to="/print-on-demand" class="nav-dropdown-item">{{ $t('nav.print_on_demand') }}</router-link>
            <router-link to="/wholesale" class="nav-dropdown-item">{{ $t('nav.wholesale') }}</router-link>
          </div>
        </div>

        <router-link to="/why" class="mobile-nav-link">{{ $t('nav.choose') }}</router-link>
        <!-- <div class="nav-dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <div class="nav-dropdown-toggle-container">
            <a href="javascript:void(0)" class="nav-dropdown-toggle">{{ $t('nav.news') }}</a>
            <span class="nav-dropdown-icon"></span>
          </div>

          <div class="nav-dropdown-menu" :class="{ active: showDropdown }">
            <router-link to="/blog" class="nav-dropdown-item">{{ $t('footer.blog') }}</router-link>
          </div>
        </div> -->
        <router-link to="/about-us" class="nav-link">{{ $t('nav.about') }}</router-link>
      </nav>

      <div class="header-right">
        <div class="language-selector">
          <div class="language-icon"></div>
          <div class="language-dropdown" :class="{ active: showLanguageDropdown }">
            <div class="language-dropdown-toggle" @click="toggleLanguageDropdown">
              <span class="current-language">{{ currentLanguage === 'cn' ? $t('lang.zh'): currentLanguage === 'en' ? $t('lang.en') : currentLanguage === 'ru' ? $t('lang.ru') : currentLanguage === 'mn' ? $t('lang.mn') : '--' }}</span>
              <span class="language-dropdown-icon"></span>
            </div>
            <div class="language-dropdown-menu">
              <a href="javascript:void(0)" @click.prevent="switchLanguage('en')" class="language-option">{{ $t('lang.en') }}</a>
              <a href="javascript:void(0)" @click.prevent="switchLanguage('cn')" class="language-option">{{ $t('lang.zh') }}</a>
              <a href="javascript:void(0)" @click.prevent="switchLanguage('ru')" class="language-option">{{ $t('lang.ru') }}</a>
              <a href="javascript:void(0)" @click.prevent="switchLanguage('mn')" class="language-option">{{ $t('lang.mn') }}</a>
            </div>
          </div>
        </div>

        <a :href="isMobile ? 'https://mclient.erlianpartner.com' : 'https://client.erlianpartner.com'" class="register-button" target="_blank">
          {{ $t('button.register') }}
        </a>
      </div>

      <button class="mobile-menu-toggle" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <nav class="mobile-nav" :class="{ active: showMobileMenu }">
      <router-link to="/" class="mobile-nav-link">{{ $t('nav.home') }}</router-link>

      <div class="nav-dropdown">
        <a href="javascript:void(0)" class="nav-dropdown-toggle" @click.prevent="toggleMobileDropdown">
          {{ $t('nav.advantages') }}
          <span class="nav-dropdown-icon"></span>
        </a>
        <div class="nav-dropdown-menu" :class="{ active: showMobileDropdown }">
          <router-link to="/sourcing" class="nav-dropdown-item">{{ $t('nav.sourcing') }}</router-link>
          <router-link to="/print-on-demand" class="nav-dropdown-item">{{ $t('nav.print_on_demand') }}</router-link>
          <router-link to="/wholesale" class="nav-dropdown-item">{{ $t('nav.wholesale') }}</router-link>
        </div>
      </div>

      <router-link to="/why" class="mobile-nav-link">{{ $t('nav.choose') }}</router-link>


      <!-- <div class="nav-dropdown">
        <a href="javascript:void(0)" class="nav-dropdown-toggle" @click.prevent="toggleMobileDropdown">
          {{ $t('nav.news') }}
          <span class="nav-dropdown-icon"></span>
        </a>
        <div class="nav-dropdown-menu" :class="{ active: showMobileDropdown }">
          <router-link to="/blog" class="nav-dropdown-item">{{ $t('footer.blog') }}</router-link>
        </div>
      </div> -->

      <router-link to="/about-us" class="mobile-nav-link">{{ $t('nav.about') }}</router-link>

      <!-- 移动端语言选择器 -->
      <!-- <div class="mobile-language-selector">
        <div class="mobile-language-dropdown" :class="{ active: showLanguageDropdown }">
          <div class="mobile-language-toggle" @click="toggleLanguageDropdown">
            <span class="mobile-language-icon"></span>
            <span class="mobile-current-language">{{ currentLanguage === 'cn' ? $t('lang.zh'): currentLanguage === 'en' ? $t('lang.en') : currentLanguage === 'ru' ? $t('lang.ru') : currentLanguage === 'mn' ? $t('lang.mn') : '--' }}</span>
            <span class="mobile-language-dropdown-icon"></span>
          </div>
          <div class="mobile-language-menu" :class="{ active: showLanguageDropdown }">
            <a href="javascript:void(0)" @click.prevent="switchLanguage('en')" class="mobile-language-option">{{ $t('lang.en') }}</a>
            <a href="javascript:void(0)" @click.prevent="switchLanguage('cn')" class="mobile-language-option">{{ $t('lang.zh') }}</a>
            <a href="javascript:void(0)" @click.prevent="switchLanguage('ru')" class="mobile-language-option">{{ $t('lang.ru') }}</a>
            <a href="javascript:void(0)" @click.prevent="switchLanguage('mn')" class="mobile-language-option">{{ $t('lang.mn') }}</a>

          </div>
        </div>
      </div> -->
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppHeader',
  data() {
    return {
      showDropdown: false,
      showLanguageDropdown: false,
      showMobileMenu: false,
      showMobileDropdown: false,
      isMobile: false,
    }
  },
  computed: {
    ...mapGetters(['currentLanguage'])
  },
  methods: {
    ...mapActions(['switchLanguage']),

    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown
    },

    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },

    toggleMobileDropdown() {
      this.showMobileDropdown = !this.showMobileDropdown
    },

    switchLanguage(lang) {
      this.$store.dispatch('switchLanguage', lang)
      this.showLanguageDropdown = false
      this.showMobileMenu = false
    },
    handleResize() {
        this.isMobile = window.innerWidth <= 1024
        this.$forceUpdate() // 强制更新计算属性
    },
  },

  mounted() {
    // 点击外部关闭下拉菜单和移动端菜单
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false
        this.showLanguageDropdown = false
        this.showMobileDropdown = false
        this.showMobileMenu = false
      }
    })

    // 监听路由变化，关闭移动端菜单
    this.$router.afterEach(() => {
      this.showMobileMenu = false
      this.showMobileDropdown = false
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style>
/* Header样式 */
.header {
  background: #fff;
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.header-container {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  gap: 8rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.mobile-menu-toggle span {
  width: 1.25rem;
  height: 0.125rem;
  background: #374151;
  margin: 0.125rem 0;
  transition: 0.3s;
}

.mobile-nav {
  display: none;
  flex-direction: column;
  background: white;
  padding: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.mobile-nav a {
  padding: 0.75rem 0;
  text-decoration: none;
  color: #374151;
  border-bottom: 1px solid #eee;
}

.mobile-nav a:last-child {
  border-bottom: none;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-link {
  display: block;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.logo-link:hover {
  transform: scale(1.05);
}

.logo img {
  height: 60px;
  width: 200px;
  object-fit: contain;
}

.nav {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.nav a {
  text-decoration: none;
  color: #374151;
  font-size: 1.1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  position: relative;
}

.nav a:hover {
  color: #64B800;
  transform: translateY(-1px);
}

/* 导航下拉菜单 */
.nav-dropdown {
  position: relative;
  display: inline-block;
}

.nav-dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-dropdown-icon {
  width: 0.6rem;
  height: 0.6rem;
  background-image: url("@/assets/images/arrow_down_brown.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
}

.nav-dropdown:hover .nav-dropdown-icon {
  transform: none;
}

.nav-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0.5rem 0;
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1000;
}

.nav-dropdown:hover .nav-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.nav-dropdown-menu a {
  display: block;
  padding: 0.75rem 1rem;
  color: #374151;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  border-radius: 0;
  transform: none;
}

.nav-dropdown-menu a:hover {
  background-color: rgba(100,184, 0, 0.1);
  color: #64B800;
  transform: none;
}

.register-button {
  background: #64B800;
  color: white;
  padding: 0 10px;
  border: none;
  font-weight: bold;
  min-width: 140px;
  height: 40px;
  cursor: pointer;
  transition: background 0.3s;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  font-size: 0.9rem;
  border-radius: 4px;
}

/* Language Selector */
.language-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 1rem;
  position: relative;
}

.language-icon {
  width: 20px;
  height: 20px;
  background: url('@/assets/images/language.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.language-dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: none;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
  font-size: 0.9rem;
}

.language-dropdown-toggle:hover {
  background-color: rgba(100,184, 0, 0.1);
  color: #64B800;
}

.current-language {
  font-weight: 500;
  color: #374151;
}

.language-dropdown-icon {
  width: 0.6rem;
  height: 0.6rem;
  background-image: url("@/assets/images/arrow_down_brown.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.3s ease;
}

.language-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0.5rem 0;
  min-width: 120px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
}

.language-dropdown.active .language-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.language-option {
  display: block;
  padding: 0.5rem 1rem;
  color: #374151;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;  /* 移除移动端点击高亮 */
  outline: none;  /* 移除焦点轮廓 */
}

.language-option:hover {
  background-color: rgba(100,184, 0, 0.1);
  color: #64B800;
}

.language-option:focus {
  outline: none;  /* 移除焦点轮廓 */
  background-color: rgba(100,184, 0, 0.1);  /* 自定义焦点样式 */
}

/* 移动端样式 */
@media (max-width: 1024px) {
    
      .mobile-menu-toggle,.mobile-nav-link,.nav-dropdown-toggle {
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }
  
  .mobile-menu-toggle:active,.mobile-nav-link:active,.nav-dropdown-toggle:active, {
    background-color: rgba(100,184, 0, 0.1);
    color: #64B800;
  }
    .language-dropdown-toggle {
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }
  
  .language-dropdown-toggle:active {
    background-color: rgba(100,184, 0, 0.1);
    color: #64B800;
  }
  .language-option {
    -webkit-tap-highlight-color: transparent;
    outline: none;
  }
  
  .language-option:active {
    background-color: rgba(100,184, 0, 0.1);
    color: #64B800;
  }
  .header-container {
    gap: 2rem;
    padding: 0 1rem;
  }

  .nav {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .mobile-nav {
    display: none;
  }

  .mobile-nav.active {
    display: flex;
  }

  .nav-dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    box-shadow: none;
    background: #f9fafb;
    margin-top: 0.5rem;
    border-radius: 4px;
  }

  .nav-dropdown-menu.active {
    display: block;
  }

  .nav-dropdown-menu:not(.active) {
    display: none;
  }

  .language-dropdown-icon {
    display: block !important;
  }

  .language-dropdown-menu {
     position: fixed;
    top: 60px;
    right: 20px;
    width: auto;
    min-width: 120px;
    max-width: 200px;
  }

  .language-dropdown.active .language-dropdown-menu {
     opacity: 1;
    visibility: visible;
    transform: translateY(0);
    max-height: none;
  }

  .language-dropdown:hover .language-dropdown-icon {
    transform: none !important;
  }

  /* 移动端语言选择器样式 */
  .mobile-language-selector {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e5e7eb;
  }
  /* .language-selector .language-icon{
    display: none !important;
  }
  .language-selector .language-dropdown{
    display: none !important;
  } */

  .mobile-language-dropdown {
    position: relative;
  }

  .mobile-language-toggle {
    display: flex;
    align-items: center;
    padding: 0.75rem 1rem;
    background: #f9fafb;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .mobile-language-toggle:hover {
    background: #f3f4f6;
  }

  .mobile-language-icon {
    width: 20px;
    height: 20px;
    background: url('@/assets/images/language.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 0.5rem;
  }

  .mobile-current-language {
    flex: 1;
    font-weight: 500;
    color: #374151;
  }

  .mobile-language-dropdown-icon {
    width: 0.6rem;
    height: 0.6rem;
    border-right: 2px solid #6b7280;
    border-bottom: 2px solid #6b7280;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
  }

  .mobile-language-dropdown.active .mobile-language-dropdown-icon {
    transform: rotate(225deg);
  }

  .mobile-language-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.2s ease;
    z-index: 1000;
    margin-top: 0.25rem;
    padding: 0 20px;
  }

  .mobile-language-menu.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .mobile-language-option {
    display: block;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    color: #374151;
    text-decoration: none;
    transition: background-color 0.2s ease;
    border-radius: 8px;
  }

  .mobile-language-option:hover {
    background-color: rgba(100,184, 0, 0.1) !important;
    color: #64B800;
  }

  .mobile-language-option:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .mobile-language-option:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
</style>
